var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":"主题色"}},[_c('div',{staticClass:"flex-row flex-valign-center"},[_c('div',{staticClass:"mr10",staticStyle:{"color":"#FFFFFF"}},[_vm._v("主题色")]),_c('el-color-picker',{staticClass:"theme-picker",attrs:{"size":"small","predefine":['#409EFF',
      '#3A71A8','#1E47AB','#304156',
      '#212121','#11a983', '#13c2c2',
      '#6959CD', '#f5222d', ],"popper-class":"theme-picker-dropdown"},model:{value:(_vm.theme),callback:function ($$v) {_vm.theme=$$v},expression:"theme"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }